import regex from '../regex';
/** @module Validators */

/**
 * @type {String}
 * @private
 * @const
 */

var MULTIPLIERS = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
var PERSONAL_ID_REGEX = /\d{6}-\d{5}/;
var CHECK_SUM_SUBTRACTOR = 1101;
var calculateSum = function calculateSum() {
  var digits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return MULTIPLIERS.reduce(function (current, next, index) {
    return current + digits[index] * next;
  }, 0);
};
var toDigits = function toDigits(personalId) {
  return personalId.replace('-', '').split('').map(function (val) {
    return parseInt(val, 10);
  });
};
var notValid = function notValid(personalId) {
  var digits = toDigits(personalId);
  var sum = calculateSum(digits);
  var checksum = digits[10];
  return (CHECK_SUM_SUBTRACTOR - sum) % 11 !== checksum;
};
export var ERROR = 'not_valid_personal_id';
/**
 * Creates validator for lv personalId
 *
 * @function idLv
 * @return {validator} lv personalId validator
 */

export default function personalIdLatvia() {
  return function (value) {
    var validateRegex = regex(PERSONAL_ID_REGEX);
    if (value && validateRegex(value) !== null) {
      return validateRegex(value);
    } else if (value && notValid(value)) {
      return ERROR;
    }
    return null;
  };
}